import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Typography,
  Tooltip ,
  IconButton ,
  CircularProgress,
  Modal,
  InputLabel,
  Select,
  Grid,
  MenuItem,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert, 
  AlertTitle,
  Backdrop, 
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetEmailDL, getSalesOffices } from "../../utils/GetAdmin";
import { saveEmailDL } from "../../utils/PostAdmin";
import requestMissingContexts, {displayConfig } from "../../utils/GetContext";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";
import { getAllWarehouseData, saveWarehouseLocation } from "../../utils/GetWarehouse";
import { deactivateRoute, getAllRoutes, updateDriverDetails } from "../../utils/GetAdminSettings";
import ResponsiveDrawer from "../ClippedResponsiveDrawer";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      width: 800,
    },
    modalInput: {
      paddingLeft: "2px", 
      paddingRight: "20px",
      marginLeft: '10px',
      marginRight: '10px', 
      width:"280px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);
interface rowData {
  param_value: string;
  email: string;
  guid:string;
  sales_org:string;

}
export default function AdminRouteManagement() {
  const classes = useStyles();
  const [routeDetails, setWarehouseLocations] = useState<any[]>([]);
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", 100);
  // const enabled = checkForRole(`${clientId}`,salesOrg,'vp_admin');
  const enabled = true;
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [editedRowDeliveringPlant, setEditedRowDeliveringPlant] = React.useState<string>("");
  const [route, setRoute] = React.useState<string>("");
  const [active, setActive] = React.useState<string>("");
  const [modalTitle, setModalTitle] = React.useState<string>("");
  const [modalStyle] = React.useState(getModalStyle);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const [backdropLoader, setBackdropLoader] = React.useState<boolean>(false);
  const [driverName,setDriverName]=React.useState<string>("");
  const [driverNumber,setDriverNumber]=React.useState<string>("");
  const driverNameRef = React.useRef<any>("");
  const driverNumberRef = React.useRef<any>("");


  const handleModalClose = () => {
    setOpenEditWindow(false);
    setEditedRowDeliveringPlant("");
    setRoute("");
    setActive("");
  }



const handleEdit = (tableMeta:any) => {
  if(tableMeta) setCurrent(tableMeta);
  setModalTitle("Edit Route Status")
  setOpenEditWindow(true);
 }


 const setCurrent = (tableMeta:any) => {
   setEditedRowDeliveringPlant(tableMeta.delivering_plant);
   setRoute(tableMeta.route);
   setActive(tableMeta.is_active);
   setDriverName(tableMeta.driver_name);
   setDriverNumber(tableMeta.driver_number);
 }
 const handleActivate= () => {
  setBackdropLoader(true)
  setOpenEditWindow(false);
  deactivateRoute(salesOrg,editedRowDeliveringPlant,route,'true').then(
    (res) => {
      getData();
      
    }
  ).catch((e) => {
    //console.log(e)
    setBackdropLoader(false);
    alert('Failed to update Route')
  })
}

const handleDriverDetails=()=>{
  setBackdropLoader(true)
  setOpenEditWindow(false);
  const currentDriverName=driverNameRef.current.value;
  const currentDriverNumber=driverNumberRef.current.value;
  // if (currentDriverName.trim().length>0||currentDriverNumber.trim().length>0) {
    updateDriverDetails(salesOrg,editedRowDeliveringPlant,route,currentDriverName,currentDriverNumber).then((res:any)=>{
      //console.log(res);
      getData();
    }).catch((e) => {
     // console.log(e)
      setBackdropLoader(false);
      alert('Failed to update Route')
    })
  // }else{
  //   setBackdropLoader(false);
  //   // alert('Failed to update Route');
  // }

}


 const handleDeactivate = () => {
  setBackdropLoader(true)
  setOpenEditWindow(false);
    deactivateRoute(salesOrg,editedRowDeliveringPlant,route,'false').then(
      (res) => {
        getData();
        setBackdropLoader(false);
      }
    ).catch((e) => {
      //console.log(e)
      alert('Failed to update Route')
      setBackdropLoader(false);
    })
 }


const modalBody = (
  <div style={modalStyle} className={classes.paper} >
  <Typography variant="h4" className={classes.modalTitle} paragraph>{modalTitle}</Typography>
  <Grid container spacing={2}  className={classes.modalGrid}>
    <Grid item xs={14} md={14} xl={12}>
  
      <Card className={classes.modalCard}>
        <CardContent>
        <Grid container rowSpacing={3} className={classes.modalGrid}>
        
          <Grid item xs={6} md={6} xl={6}>
            <InputLabel >Delivery Plant</InputLabel>
           <TextField placeholder='Delivery Plant' type='text'
                className={classes.modalInput}
                disabled={true}
                value={editedRowDeliveringPlant}
               ></TextField>
          </Grid>
          <Grid item xs={6} md={6} xl={6}>
            <InputLabel >Route</InputLabel>
            <TextField placeholder='route' type='text'
                className={classes.modalInput}
                disabled={true}
                value={route}
               ></TextField>
            </Grid>
            <Grid item xs={6} md={6} xl={6}>
            <InputLabel >Driver Name</InputLabel>
           <TextField placeholder='Driver Name' type='text'
                className={classes.modalInput}
                inputRef={driverNameRef}
                defaultValue={driverName}
               ></TextField>
          </Grid>
          <Grid item xs={6} md={6} xl={6}>
            <InputLabel >Driver Number</InputLabel>
            <TextField placeholder='Driver Number' type='text'
                className={classes.modalInput}
                inputRef={driverNumberRef}
                defaultValue={driverNumber}
               ></TextField>
            </Grid>
            <Grid container justifyContent={'flex-end'} alignItems={"center"} item xs={12} md={12} xl={12}>
            <Button variant="contained" color="success" onClick={handleDriverDetails}>Save</Button>
            <Button variant="contained" color="success" disabled={!!active} onClick={handleActivate}>Activate</Button>
            <Button variant="contained" disabled={!active} onClick={handleDeactivate}>Deactivate</Button>
            </Grid>
          </Grid>
          </CardContent>
        </Card>
        <div style={{ paddingRight: "5px", textAlign:"right"}}>
              <React.Fragment>
                  <Tooltip title={"Cancel"}>
                      <IconButton onClick={handleModalClose}>
                          <Clear />
                      </IconButton>
                  </Tooltip>
              </React.Fragment>
            </div>
      </Grid>
    </Grid>
  </div>
);

  useEffect(() => {
    if (doneLoading) return;
      getData();
  }, [routeDetails,doneLoading,salesOrg,muiTable]);

  const getData =()=>{
    getAllRoutes(salesOrg).then((v) => {
      if(v && v.data){ 
      setWarehouseLocations(v.data);
      }
      setBackdropLoader(false);
      setDoneLoading(true);
    })
  }
  
  return (
    <ResponsiveDrawer
      title="Route Management"
    >
    <div className={classes.root}>
      {doneLoading && enabled? (
        <TableAbstraction
        settingsKey="Route_Mgmnt"
          options={{
            draggableColumns: {
              enabled: true,
            },
            rowsPerPageOptions: [25, 50, 100],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            },
          }}
          title="Route Management"
          columns={[
            {
                label: "Delivery Plant",
                name: "delivering_plant",
                options: {
                  searchable: true,
                  filter: true,
                },
            },
            {
                label: "Route",
                name: "route",
                options: {
                  searchable: false,
                  filter: false,
                },
            },
            
            {
                label: "Active",
                name: "is_active",
                options: {
                  filter: false,
                  searchable:true,
                  
                },
           },
           {
            label: "No. of Customers",
            name: "customer",
            options: {
              filter: false,
              searchable:false
            },
          },
          {
            label: "Driver Name",
            name: "driver_name",
            options: {
              filter: false,
              searchable:true,
              
            },
          },
          {
            label: "Driver Number",
            name: "driver_number",
            options: {
              filter: false,
              searchable:true,
              
            },
          },

          {
            label: " ",
            name: "remove",
            options: {
              filter: false,
              setCellProps: () => ({ align: 'right' }),
              renderCell: (props) => {
                const tableMeta = props.row;
                  if(!!useCompact)
                  return (
                      <React.Fragment>
                        <Tooltip title={"Edit"}>
                          <IconButton>
                          <EditIcon 
                            fontSize="small"  
                            onClick={() => {handleEdit(tableMeta)}}/>
                          </IconButton>
                        </Tooltip>
                        
                      </React.Fragment>
                    );
                  else
                    return (
                        <React.Fragment>
                          <Tooltip title={"Edit"}>
                            <IconButton onClick={() => {handleEdit(tableMeta)}}>
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                        </React.Fragment>
                      );
              }
              
            },
          },
            
          ]}
          data={routeDetails}
        />
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
      
      <Modal
        open={openEditWindow}
        onClose={handleModalClose}
      >
        {modalBody}
      </Modal>

         {/* backdrop loader */}
      <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={backdropLoader}>
        <CircularProgress color="primary" />
      </Backdrop>
    </div>
    </ResponsiveDrawer>
  );
}